var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit, QueryList } from '@angular/core';
import { ProductOrderOptionComponent } from './product-order-option/product-order-option.component';
import { DtvCatalogUtils } from '../../utils/dtv-catalog/dtv-catalog.utils';
import { TvShopEntertainmentPack } from '../../model/tv-shop-entertainment-pack';
import { OmapiIdConstants } from '../../shared/omapi-id-constants';
import { BaseActions } from '../../shared/base-actions';
import { takeUntil } from 'rxjs/operators';
import { ImageUtils } from '../../shared/utils/image/image-utils';
import { Emitter } from '../../shared/utils/emitter/emitter';
import { EmitterConstants } from '../../shared/emitter-constants';
import { TvShopStateService } from '../../services/state/tv-shop-state.service';
var ProductDetailOrderOptionsComponent = /** @class */ (function (_super) {
    __extends(ProductDetailOrderOptionsComponent, _super);
    function ProductDetailOrderOptionsComponent(stateService) {
        var _this = _super.call(this) || this;
        _this.stateService = stateService;
        _this.emitOrderProduct = new EventEmitter();
        _this.emitOrderTrial = new EventEmitter();
        _this.playSportsOptions = [{
                name: 'play-sports',
                omapiId: OmapiIdConstants.PLAY_SPORTS,
                descriptionKey: 'eos-tv-shop-ii.text.play-sports-details-order-options-sports',
                titleKey: 'eos-tv-shop-ii.title.play-sports-details-order-options-sports',
                priceDetail: null
            }, {
                name: 'daypass',
                isDayPass: true,
                omapiId: OmapiIdConstants.DAY_PASS,
                descriptionKey: 'eos-tv-shop-ii.text.play-sports-details-order-options-day-pass',
                titleKey: 'eos-tv-shop-ii.title.play-sports-details-order-options-day-pass',
                priceDetail: null
            }, {
                name: 'trial-box',
                isTrial: true,
                omapiId: OmapiIdConstants.TRIALS,
                descriptionKey: 'eos-tv-shop-ii.text.play-sports-details-order-options-trial-box',
                titleKey: 'eos-tv-shop-ii.title.play-sports-details-order-options-trial-box',
                priceDetail: null
            }
        ];
        return _this;
    }
    ProductDetailOrderOptionsComponent.prototype.ngOnInit = function () {
        this.subscribeToTrialActivation();
        var packs = this.stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPacks; });
        var pack = DtvCatalogUtils.getTvShopEntertainmentPackForOmapiId(packs, this.omapiId);
        this.enrichPlaySportsOptions(pack);
        this.processOverlay(pack);
        var price = DtvCatalogUtils.getPriceForProduct(packs, OmapiIdConstants.DAY_PASS);
        this.enrichPlaySportDaypassOption(price);
    };
    ProductDetailOrderOptionsComponent.prototype.subscribeToTrialActivation = function () {
        var _this = this;
        Emitter.of(EmitterConstants.OPEN_TRIAL_SUCCESS_MODAL)
            .pipe(takeUntil(this.stopSubscription)).subscribe(function (trial) {
            if (trial.omapiId === OmapiIdConstants.PLAY_SPORTS_TRIAL) {
                _this.hasTrial = true;
            }
        });
    };
    ProductDetailOrderOptionsComponent.prototype.processOverlay = function (pack) {
        var _this = this;
        this.playSportsOptions.forEach(function (option) { return option.showPrices = _this.shouldShowPrices(pack, option); });
        this.isDowngrade = pack.isDowngrade;
        this.hasPackageAlready = pack.subscribed;
        this.hasDaypass = pack.hasDayPass;
        this.hasTrial = pack.hasTrial;
    };
    ProductDetailOrderOptionsComponent.prototype.shouldShowPrices = function (pack, option) {
        return !pack.isDowngrade && !pack.subscribed && !(option.omapiId !== OmapiIdConstants.PLAY_SPORTS && (pack.hasDayPass || pack.hasTrial));
    };
    ProductDetailOrderOptionsComponent.prototype.enrichPlaySportsOptions = function (pack) {
        this.playSportsOptions.filter(function (option) { return option.omapiId === pack.omapiId; }).forEach(function (option) {
            option.pack = pack;
            option.priceDetail = pack.priceDetail;
            option.isUpgrade = pack.isUpgrade;
        });
    };
    ProductDetailOrderOptionsComponent.prototype.enrichPlaySportDaypassOption = function (price) {
        this.playSportsOptions.filter(function (option) { return option.omapiId === OmapiIdConstants.DAY_PASS; }).forEach(function (option) {
            option.pack = new TvShopEntertainmentPack();
            option.pack.omapiId = OmapiIdConstants.DAY_PASS;
            option.pack.isDowngrade = false;
            option.priceDetail = price;
            option.pack.isDayPass = true;
        });
    };
    Object.defineProperty(ProductDetailOrderOptionsComponent.prototype, "backgroundImageUrl", {
        get: function () {
            return ImageUtils.getBackgroundImageUrl(this.omapiId, 'order');
        },
        enumerable: true,
        configurable: true
    });
    ProductDetailOrderOptionsComponent.prototype.isPlaySports = function () {
        return this.omapiId === OmapiIdConstants.PLAY_SPORTS;
    };
    ProductDetailOrderOptionsComponent.prototype.onEmitOrderProduct = function (event) {
        this.emitOrderProduct.emit(event);
    };
    ProductDetailOrderOptionsComponent.prototype.onEmitOrderTrial = function (event) {
        this.emitOrderTrial.emit(event);
    };
    Object.defineProperty(ProductDetailOrderOptionsComponent.prototype, "showOverlay", {
        get: function () {
            return this.hasPackageAlready || this.isDowngrade || this.hasDaypass || this.hasTrial;
        },
        enumerable: true,
        configurable: true
    });
    return ProductDetailOrderOptionsComponent;
}(BaseActions));
export { ProductDetailOrderOptionsComponent };
